import React from "react";
import "./ConsignmentOptions.css";

const ConsignmentOptions = ({
  onSubmitHere,
}) => {
  const openConsignmentForm = () => {
    window.open(
      "https://leon-gallery.com/request",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const contactLeonGallery = () => {
    window.location.href =
      "mailto:info@leon-gallery.com";
  };

  return (
    <div className="consignment-options">

      <div className="consignment-options-title">
        How would you like to proceed?
      </div>

      {/* SUBMIT HERE */}
      <button
        type="button"
        className="consignment-option-card"
        onClick={onSubmitHere}
      >
        <div className="consignment-option-icon">
          📷
        </div>

        <div className="consignment-option-content">
          <div className="consignment-option-title">
            Submit Here
          </div>

          <div className="consignment-option-description">
            Upload your artwork and provide the
            details directly through this chat.
          </div>
        </div>

        <div className="consignment-option-arrow">
          ›
        </div>
      </button>

      {/* CONSIGNMENT REQUEST */}
      <button
        type="button"
        className="consignment-option-card"
        onClick={openConsignmentForm}
      >
        <div className="consignment-option-icon">
          🔗
        </div>

        <div className="consignment-option-content">
          <div className="consignment-option-title">
            Consignment Request
          </div>

          <div className="consignment-option-description">
            Open the official Leon Gallery
            consignment request form.
          </div>
        </div>

        <div className="consignment-option-arrow">
          ›
        </div>
      </button>

      {/* CONTACT */}
      <button
        type="button"
        className="consignment-option-card"
        onClick={contactLeonGallery}
      >
        <div className="consignment-option-icon">
          📧
        </div>

        <div className="consignment-option-content">
          <div className="consignment-option-title">
            Contact Leon Gallery
          </div>

          <div className="consignment-option-description">
            Email us at info@leon-gallery.com
          </div>
        </div>

        <div className="consignment-option-arrow">
          ›
        </div>
      </button>

    </div>
  );
};

export default ConsignmentOptions;